import axios from 'axios';
export class FaqRenderer
{
    constructor(
        private faqApiEndpoint: string
    )
    {

    }

    async render(elementOrSelector: string | Element | Element[], conceptCode: string)
    {
        if (typeof elementOrSelector === "string")
            elementOrSelector = Array.from(globalThis.document.querySelectorAll(elementOrSelector));

        if (!(elementOrSelector instanceof Array))
            elementOrSelector = [ elementOrSelector ];

        const faqs = (await axios.get<{question: string, answer: string}[]>(
            this.faqApiEndpoint, 
            {
                params: {
                    conceptCode: conceptCode
                }
            })).data;
        
        const cardsFn = (accordianIdentifier: string | number) => 
        {
            return faqs.map((faq, index) => {
                const headingId = `faq_heading-${accordianIdentifier}-${index}`;
                const collapseId = `faq_collapse-${accordianIdentifier}-${index}`;
                return `
                    <div class="card">
                        <div class="card-header" id="${headingId}">
                            <h5 class="mb-0">
                                <a class="toggle-collapse collapsed" 
                                    role="button" 
                                    data-toggle="collapse" 
                                    data-target="#${collapseId}" 
                                    aria-expanded="false" 
                                    aria-controls="${collapseId}">
                                    ${faq.question}
                                    <span class="circle_qa"></span>
                                </a>
                            </h5>
                        </div>
                        <div id="${collapseId}" 
                            class="collapse" 
                            aria-labelledby="${headingId}">
                            <div class="card-body">
                                ${faq.answer}
                            </div>
                        </div>
                    </div>
                `;    
            });
        } 

        elementOrSelector.forEach((element, key) => 
            {
                element.innerHTML = `
                    <section class="accordion faq_sec">
                        <div class="container">
                            <div class="row">
                                <div class="col-lg-12 col-md-12">
                                    <div class="faq_wrap">
                                        ${cardsFn(key).join(" ")}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                `;
        });
    }
} 